define('plugin/news/view/NewsIndexView',['require','marionette','plugin/news/view/NewsItemView','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var NewsItemView = require('plugin/news/view/NewsItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * News composite view (news container)
     *
     * @class NewsIndexView
     */
    return Marionette.CompositeView.extend({

        template: '#news_list_view',
        childView: NewsItemView,
        childViewContainer: '#sb_news_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'news'
            });
        }

    });

});
